import React from "react";
import { Grid, Typography } from "@mui/material";
import BookingCostBreakdown from "./BookingCostBreakdown";
import BookingInfo from "./BookingInfo/BookingInfo";
import moment from "moment";
import {DateFormats} from "../../constants/securspace-constants";
import type {Supplier} from "../../../types/Supplier";

const titleSx = {
  marginBottom: '0.71em',
} as const;

interface BookingDetailsProps {
  bookingLocation: Supplier;
  startDate: string;
  setStartDate?: (value: string) => void;
  endDate: string;
  setEndDate?: (value: string) => void;
  assetType: string;
  setAssetType?: (value: string) => void;
  numberSpaces: number;
  setNumberSpaces?: (value: number) => void;
  monthly: boolean;
  costData: Record<string, any> | null;
  disableBookingChanges: boolean;
  instantApproval: boolean;
  isBrokeredBooking: boolean;
  assetTypelist: string[];
  calculatingCostData: boolean;
  setBookingIsValid?: (value: boolean) => void;
  displayCalculatedCostData: boolean;
  onToggleEditMode?: (value: boolean) => void;
}

/**
 * Displays booking details and cost breakdown for a booking.
 */
const BookingDetails = (props: BookingDetailsProps) => {

  const {
    bookingLocation,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    assetType,
    setAssetType,
    numberSpaces,
    setNumberSpaces,
    monthly,
    costData,
    disableBookingChanges,
    instantApproval,
    isBrokeredBooking,
    assetTypelist,
    calculatingCostData,
    onToggleEditMode,
    displayCalculatedCostData,
  } = props;

  const handleStartDateChange = (value: string | moment.Moment) => {
    setStartDate?.(moment(value).isValid() ? moment(value).format(DateFormats.DAY) : String(value));
  };

  const handleEndDateChange = (value: string | moment.Moment) => {
    setEndDate?.(moment(value).isValid() ? moment(value).format(DateFormats.DAY) : String(value));
  };

  return <Grid item>
    <Typography variant={'h5'} color={'textPrimary'} sx={titleSx}>Details</Typography>
    <BookingInfo
      instantApproval={instantApproval}
      bookingLocation={bookingLocation}
      startDate={startDate}
      endDate={endDate}
      setStartDate={handleStartDateChange}
      setEndDate={handleEndDateChange}
      assetType={assetType}
      {...(setAssetType ? { setAssetType } : {})}
      monthly={monthly}
      numberSpaces={numberSpaces}
      {...(setNumberSpaces ? { setNumberSpaces } : {})}
      disableDatePickerPast={!isBrokeredBooking}
      isBrokeredBooking={isBrokeredBooking}
      disableBookingChanges={disableBookingChanges}
      assetTypelist={assetTypelist}
      {...(onToggleEditMode ? { onToggleEditMode } : {})}
    />
    <BookingCostBreakdown
      isBrokered={isBrokeredBooking}
      monthly={monthly}
      startDate={startDate}
      costData={costData}
      calculatingCostData={calculatingCostData}
      displayCalculatedCostData={displayCalculatedCostData}
    />
  </Grid>
}

export default BookingDetails;
